import { Typography } from '@mui/material'
import React from 'react'
import { PropsTextFunction } from '../../../styles'

export const CaptionText = (props) => {
  return (
    <Typography
    variant="caption"
    component="p"
    sx={ PropsTextFunction(props) }
>
  { props?.icon }
    { props?.text }
</Typography>
  )
}
